module.exports = __webpack_public_path__ + "static/media/ajax.2795993d.png";